<% if (validated_invalid_patient_type_message_key) { %>
  <%= renderPartial('appointment_booking/wizard/templates/step/confirmation/callouts/invalid_patient_type/' + validated_invalid_patient_type_message_key, obj) %>
  <%= validated_invalid_patient_type_message_contact_info %>
<% } %>
